import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import {Pagination} from 'app/entities/pagination.entity';
import {IonInfiniteScroll} from '@ionic/angular';
import {ListModelService} from 'app/core/list.interface';
import {Entity} from 'app/core/main.entity';
import {HelperService} from 'app/services/helper.service';

@Component({
  selector: 'app-list',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListComponent implements AfterViewInit {

  @ContentChild(TemplateRef) templateRef: TemplateRef<any>;

  @Input() modelService: ListModelService;
  @Input() filters: any;

  @Input() emptyText: string;
  @Input() emptyIcon: string;
  @Input() emptyHeight: string = '';
  @Input() itemsPerPage = 50;

  @Input() disablePagination = false;
  @Input() top = false;
  @Input() dateField: string = 'date';
  @Input() showDateDivider = false;
  @Input() showAllItems = false;

  @Output() beforeLoad = new EventEmitter();
  @Output() afterLoad = new EventEmitter();

  items: Entity[] = [];
  pagination: Pagination = new Pagination();

  firstLoading = true;
  loading = false;

  data: any;

  response = true;
  HelperService = HelperService;

  cdr: ChangeDetectorRef;

  constructor(cdr: ChangeDetectorRef) {
    this.cdr = cdr;
  }

  ngAfterViewInit() {
    // this.loadItems();
  }

  async loadItems(reset = false, scroll: IonInfiniteScroll = null) {
    this.beforeLoad.emit(reset);

    if (reset && !this.firstLoading) {
      this.loading = true;
    }

    if (reset) {
      this.items = [];
      this.pagination.currentPage = 1;
    }

    this.modelService.getItems(this.pagination.currentPage, this.filters, (items, pagination, data) => {
      if (items === null) {
        this.response = !!items;
      } else {

        this.items = [...this.items, ...items] as any[];

        this.pagination = pagination;
      }
      this.data = data;
      this.cdr.markForCheck();
      this.loadFinished(scroll);
    });
  }

  loadFinished(scroll: IonInfiniteScroll = null) {
    if (scroll != null) {
      scroll.complete();
    }

    if (this.firstLoading) {
      this.firstLoading = false;
    } else {
      this.loading = false;
    }

    this.afterLoad.emit({items: this.items, data: this.data});
  }

  loadNextPage(scroll: IonInfiniteScroll = null) {
    this.pagination.currentPage++;
    this.loadItems(false, scroll);
  }

  isNewMonth(item, previous) {
    if (!item[this.dateField]) {
      return false;
    }

    if (typeof previous === 'undefined') {
      return true;
    }

    return item[this.dateField]?.getMonth() !== previous[this.dateField]?.getMonth();
  }

  isNewYear(item, previous) {
    if (!item[this.dateField]) {
      return false;
    }

    if (typeof previous === 'undefined') {
      return true;
    }

    return item[this.dateField]?.getFullYear() !== previous[this.dateField]?.getFullYear();
  }
}
